import { Box, Modal } from "@mui/material";
import { IoWarningOutline } from "react-icons/io5";
import { RxCross1 } from "react-icons/rx";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const ModalSaveDefecta = ({ open, setOpen, setConfirm }) => {
  const handleClose = () => {
    setConfirm(false);
    setOpen(false);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          ...style,
          maxWidth: "75%",
          overflowY: "auto",
          overflowX: "wrap",
          maxHeight: "50vh",
          padding: 0,
        }}
        className="text-left text-base w-3/4 lg:w-1/3"
      >
        <div className="px-8 my-4 text-center">
          <p className=" text-[18px] mb-2">Lanjut Buat PO</p>
          <p>Apakah Anda ingin membuat PO untuk produk terpilih</p>
        </div>

        <div className="px-8 mb-4 flex gap-2 items-center">
          <button
            type="button"
            className="w-full border-2 py-2 px-4 rounded-md bg-[#F1FAF0] border-[#6F955B] text-[#6F955B] hover:bg-gray-300"
            onClick={() => {
              setOpen(false);
              setConfirm(false);
            }}
          >
            Batal
          </button>
          <button
            type="button"
            className="w-full border-2 py-2 px-4 rounded-md bg-[#6F955B] border-[#6F955B] text-white hover:bg-gray-300"
            onClick={() => {
              setConfirm(true);
              setOpen(false);
            }}
          >
            Lanjut
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default ModalSaveDefecta;
